import { Typography, Stack, Breadcrumbs, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IDoriBreadcrumbs } from "./Models/IDoriBreadcrumbs";
import "./Styles/DoriBreadcrumbs.scss"

const DoriBreadcrumbs = ({ routes }: IDoriBreadcrumbs) => {

    const navigate = useNavigate();

    const handleClick = (link) => {
        navigate(link)
    }

    const breadcrumbs = [
        routes.map((route: any) => {
            return (
                <Box onClick={() => handleClick(route.link)}>
                    <Typography color="text.primary" className="breadcrumbsLabel">
                        {route.title}
                    </Typography>
                </Box>
            )
        })
    ];

    return (
        <Stack spacing={1}>
            <Breadcrumbs separator={"/"} aria-label="breadcrumb">
                {breadcrumbs}
            </Breadcrumbs>
        </Stack>
    );
}

export default DoriBreadcrumbs;